import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, useMediaQuery, useTheme
} from "@material-ui/core";

import { observer } from "mobx-react";
import {
    MenuItemModifier,
} from "../../../../../services/menu/models";
import {

    Typography
} from "../../../../../common/components/libs";
import { localize } from "../../../../../common/libs";
import {Trans, useTranslation} from "react-i18next";

interface Props {
    current?: MenuItemModifier
    open: boolean,
    handleDone: () => void,
    removeModifier: () => void;
}

const RemoveModifierForm = ({ open,removeModifier, current, handleDone }: Props) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const {t} = useTranslation(["general", "menu"]);
    const handleSubmit = async () => {
        removeModifier();
        handleDone();
    };

    if(!current) return null;

    return (
        <>
            <Dialog
                open={open}
                onClose={handleDone}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
                fullScreen={!isSm}
            >
                <DialogTitle id="form-dialog-title">
                    {t("menu:modifiersSet.deletingModifiersSet")}
                </DialogTitle>
                <DialogContent>
                    <form autoComplete="off">
                        <div style={{display: "flex", alignContent: "space-around"}}>
                            <div style={{flexGrow: 1}}>
                                <Typography variant={"body2"}  mb={3}>
                                    {t("menu:modifiersSet.youGoingRemoveModifiersSet")} '{localize(current.data.name)}'
                                    <br/>
                                    {t("menu:modifiersSet.modifiersSetWillDeletedFromPositions")}
                                </Typography>
                            </div>
                        </div>
                    </form>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleDone} color="primary">
                        {t("general:cancel")}
                    </Button>
                    <Button
                        color="default"
                        onClick={handleSubmit}
                    >
                        {t("menu:modifiersSet.wantDelete")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

};

export default observer(RemoveModifierForm);
